const TYPE_PRESETS = [
  { keys: ["frontend", "фронт"], icon: "</>", hue: 197 },
  { keys: ["backend", "бэкенд", "бекенд"], icon: "{ }", hue: 145 },
  { keys: ["design", "дизайн"], icon: "UI", hue: 324 },
  { keys: ["devops"], icon: "OPS", hue: 36 },
  { keys: ["mobile"], icon: "APP", hue: 266 },
  { keys: ["data"], icon: "DB", hue: 214 },
  { keys: ["qa", "тест"], icon: "QA", hue: 18 },
  { keys: ["management", "управ"], icon: "PM", hue: 52 },
  { keys: ["other", "проч"], icon: "AI", hue: 285 },
];

export function normalizeTechnologyLabel(value) {
  return String(value || "").trim().toLowerCase();
}

function hashToHue(value) {
  const text = String(value || "");
  let hash = 0;
  for (let i = 0; i < text.length; i += 1) {
    hash = (hash << 5) - hash + text.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash) % 360;
}

function getTypePreset(typeLabel) {
  const normalized = normalizeTechnologyLabel(typeLabel);
  return (
    TYPE_PRESETS.find((preset) =>
      preset.keys.some((key) => normalized.includes(key)),
    ) || null
  );
}

export function buildTechnologyCatalogMeta(catalog) {
  const types = Array.isArray(catalog?.types) ? catalog.types : [];
  const technologies = Array.isArray(catalog?.technologies)
    ? catalog.technologies
    : [];

  const typeById = {};
  types.forEach((type) => {
    const typeId = Number(type?.id);
    if (!Number.isFinite(typeId)) {
      return;
    }

    const label = String(type?.label || "").trim() || "Other";
    const preset = getTypePreset(label);
    typeById[typeId] = {
      id: typeId,
      label,
      icon: preset?.icon || label.slice(0, 2).toUpperCase() || "##",
      hue: preset?.hue ?? hashToHue(label),
    };
  });

  const technologyByLabel = {};
  technologies.forEach((technology) => {
    const label = String(technology?.label || "").trim();
    if (!label) {
      return;
    }

    const typeId = Number(technology?.type_id);
    const typeMeta = typeById[typeId] || null;
    const fallbackHue = hashToHue(label);

    technologyByLabel[normalizeTechnologyLabel(label)] = {
      id: Number(technology?.id) || 0,
      label,
      typeId: Number.isFinite(typeId) ? typeId : null,
      typeLabel: typeMeta?.label || "Other",
      icon: typeMeta?.icon || label.slice(0, 2).toUpperCase() || "##",
      hue: typeMeta?.hue ?? fallbackHue,
    };
  });

  return { typeById, technologyByLabel };
}

export function getTechnologyVisual(label, catalogMeta) {
  const normalized = normalizeTechnologyLabel(label);
  if (normalized && catalogMeta?.technologyByLabel?.[normalized]) {
    return catalogMeta.technologyByLabel[normalized];
  }

  const cleaned = String(label || "").trim();
  return {
    id: 0,
    label: cleaned,
    typeId: null,
    typeLabel: "Other",
    icon: cleaned.slice(0, 2).toUpperCase() || "##",
    hue: hashToHue(cleaned),
  };
}
